import React from "react";

const LazyTvImage = React.lazy(() => import("./tv-image"));

const TvImage = (props: Record<string, any>) => (
  <React.Suspense fallback={<div className='transition-loader'><img src='/images/running-horse.gif' /></div>}>
    <LazyTvImage {...props} />
  </React.Suspense>
);

export default TvImage;
